// extracted by mini-css-extract-plugin
export default {"headerBlock":"TranslationsPage_headerBlock__+mfXG","middleBlock":"TranslationsPage_middleBlock__n7yFm"};